import React from "react";

function PrivateEquity() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Private Equity</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              Private equity investors will require legal advice when making management buy-outs or any other types of transactions.
              </p>
              <p>
              Banking and employment documentation is looked at in this context.  Legal Drafting is essential for the protection of the client. 
              </p>
              <p>
              Corporate specifications apply to such private equity investors involved in transactions. 
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default PrivateEquity;
